<template>
	<div class="header-page">
    <div class="header-content" @touchmove.prevent>
        <div class="disflex" style="justify-content: space-between;">
          <div class="chances-top disflex crfff ac" @click="getMenu('purchaseChances')">
            <div>
              <strong class="crfff"><img width="20" src="../../static/images/hd-i1.png">{{info.score}}</strong>
              <div>{{$t('Chances')}}</div>
            </div>
          </div>
          <a class="logo logo-w" href="/"><img src="static/images/logo.png" /></a>
          <div class="account-top disflex crfff ac" @click="getAcount()" @click.stop>
            <div>
              <img width="20" src="static/images/hd-i2.png" v-if="isShow">
              <img width="20" src="static/images/hd-i2.png" v-else>
              <div>{{$t('Setting')}}</div>
            </div>
          </div>
        </div>
          <div class="modal-bg" v-if="isActive"></div>
        <div class="menu-bg" v-if="isActive">
          <div class="disflex mt50" style="justify-content: flex-start;">
            <img width="25" @click="isActive=false" src="../../static/images/back.png" />
            <a class="logo" style="margin: 0 0 0 0.64rem;" href="/"><img src="static/images/logo.png" /></a>
          </div>
          <div class="account ac" @click="getMenu('myAccount')">
            <div class="mt30">
              <img src="static/images/account.png" />
            </div>
            <div class="crfff fw7">{{info.nickname}}</div>
          </div>
          <div class="chances-left ac mt20">
            <div class="cr46eed0">{{$t('ChancesLeft')}}: <strong class="crfff"><img width="22" src="../../static/images/hd-i1.png">{{info.score}}</strong></div>
            <div class="chances-bt" :class="{'active':isShowMenu=='purchaseChances'}" @click="getMenu('purchaseChances')">{{$t('PurchaseChances')}}<img width="16" src="../../static/images/by-i1.png"></div>
          </div>
          <div class="menu-list">

            <div class="" :class="{'active':isShowMenu=='history'}" @click="getMenu('history')"><img width="10" src="../../static/images/m-i1.png">{{$t('History')}}</div>
            <div class="" :class="{'active':isShowMenu=='billing'}" @click="getMenu('billing')"><img width="14" src="../../static/images/m-i2.png">{{$t('Billing')}}</div>
            <div class="" :class="{'active':isShowMenu=='guidance'}" @click="getMenu('guidance')"><img width="12" src="../../static/images/m-i3.png">{{$t('Guidance')}}</div>
            <div class="" :class="{'active':isShowMenu=='invitation'}" @click="getMenu('invitation')"><img width="14" src="../../static/images/m-i4.png">{{$t('invitation')}}</div>
            <div class="" :class="{'active':isShowMenu=='faq'}" @click="getMenu('faq')"><img width="14" src="../../static/images/m-i5.png">{{$t('FAQ')}}</div>
<!--            <div class="" :class="{'active':isShowMenu=='language'}" @click="getLan('language')"><img width="14" src="../../static/images/en.png">{{$t('language')}}</div>-->
          </div>
         <div class="ac">
            <button class="button" style="width: 100%;" @click="unSubscribe">{{$t('unsubscribe')}}</button>
          </div>
        </div>
    </div>


    <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;z-index: 1500">
        <div class="alert-modal" style="width: 95%;" slot="mdBox" >
            <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 50px;">×</div>
            <div class="information mt100 crfff ac por">
              <div class="fs50">{{$t('language')}}</div>
              <div class="fs26 mt30 cr0062ff">{{$t('languageTips')}} :</div>
                <div class="change-list change-list2 ac">
                  <div class="one" @click="getLang(2,'en')" :class="{'active':isShowLang=='en'}">
                    <img class="dui" src="../../static/images/dui.png">
                    <img style="width:1.2rem" :src="isShowLang=='en'?'../../static/images/en.jpg':'../../static/images/en.jpg'" />
                    <span>{{$t('English')}}</span>
                  </div>
                  <div class="one" @click="getLang(2,'bur')" :class="{'active':isShowLang=='bur'}">
                    <img class="dui" src="../../static/images/dui.png">
                    <img style="width:1.2rem" :src="isShowLang=='bur'?'../../static/images/en1.jpg':'../../static/images/en1.jpg'" />
                    <span>{{$t('Myanmar')}}</span>
                  </div>
                </div>
              <div class="ac mt50">
                <button class="button fw7" @click="getLang(1)">{{$t('change')}}</button>
              </div>
            </div>
        </div>
    </Dialog>
	</div>
</template>

<script>
    import Dialog from '../components/dialog'
    export default {
        name: 'app-header',
        components:{
          Dialog
        },
        data () {
            return {
              info:{},
              isShow:false,
              isActive:false,
              isShowMenu:false,
              isLogin:false,
              isEnShow:false,
              lang:'',
              isShowLang:'bur',
            }
        },
        created(){
          if(localStorage.getItem('lang')){
            this.isShowLang = localStorage.getItem('lang')
          }
          this.getInfo()
        },
		methods: {
      getLan(){
        let that = this
        that.$refs.imgDialog.showMaskFun();
      },
      closeTmgDialog(){
        this.$refs.imgDialog.closeMask();
      },

      getLang(type,lang){
        if(type==1){
          localStorage.setItem('lang',this.lang)
          // this.$router.push({path:'/',query:{}});
          location.reload()
        }else{
          this.isShowLang = lang
          this.lang = lang
        }
      },
      getMenu(url){
          this.isShowMenu = url
          let that = this
          setTimeout(function(){
            that.$router.push({path:url,query:{url:url}});
          },500);
      },
			getAcount(){
				let that =this;
			  this.isActive = true;
        // this.getInfo()
			},
      getShowLogin(){
        this.$router.push({path:'/login'})
      },
      unSubscribe(){
      	let that =this;
      	that.$parent.$parent.loadModal(true);
      	that.$api.post('api/user/unsub',null,r =>{
      		that.$parent.$parent.returnCode(r,function(){
      	    that.$parent.$parent.loadModal(false);
            that.$utils.alertText(r.msg,80);
      	    localStorage.removeItem('token')
      	    localStorage.removeItem('mobile')
            // that.$router.push({path:'/login'});
            window.location.href = "https://snapai.asia/"
      	  });
      	})
      },
      getInfo (){
        let that =this;
        that.$parent.$parent.loadModal(true);
        that.$api.post('/api/user/info',null,r =>{
        	that.$parent.$parent.returnCode(r,function(){
            that.info = r.data
            localStorage.setItem('info',r.data.score)
            localStorage.setItem('int_url',r.data.invite_url)
            that.$parent.$parent.loadModal(false);
          });
        })
      }
		}
    }
</script>
<style>
  .modal-bg {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .5);
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;

  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderOne.vue